import { Contracts } from "../contracts/contracts";

export class ImportHoardingConfig {
    contract: Contracts;
    showImportHoarding: boolean = false;
}